<template>
  <b-container>
    <b-card title="Trial" class="mb-4"  v-if="trial_days_left !== undefined">
      <p v-if="trial_days_left > 0">You have <strong>{{trial_days_left}} day{{trial_days_left != 1 ? 's' : ''}}</strong> left of your trial. Upgrade to keep your site live after your trial is over.</p>
      <p v-else>Your trial is over. Your site has been unpublished. Upgrade now to publish it agina!</p>
      <p>You will be billed <strong>£100 / month</strong>.</p>
      <LoadingButton type="submit" variant='primary' :loading="is_saving" @click="can_update_plan">Upgrade</LoadingButton>
      <SelectCard :profile="profile" :modal_only="true" ref="select_card" :action="update_plan" />
    </b-card>

    <b-card title="Monthly Plan" class="mb-4" v-if="trial_days_left === undefined">
      <b-table-simple>
        <b-tr>
          <b-td>Hosting</b-td>
          <b-td>£100</b-td>
        </b-tr>
        <b-tr>
          <b-td>{{site.monthly_posts}} post{{site.monthly_posts != 1 ? 's' : ''}} per month</b-td>
          <b-td>£{{site.monthly_posts * 40}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>{{site.monthly_citations}} citation{{site.monthly_posts != 1 ? 's' : ''}} per month</b-td>
          <b-td>£{{site.monthly_citations * 4}}</b-td>
        </b-tr>
        <b-tr>
          <b-td></b-td>
          <b-td>Total £{{100 + site.monthly_citations * 4 + site.monthly_posts * 40}}</b-td>
        </b-tr>
      </b-table-simple>
    </b-card>

    <b-card title="Payment method" class="mb-4" v-if="trial_days_left === undefined">
      <SelectCard :profile="profile" />
    </b-card>

    <b-card title="Invoices" v-if="trial_days_left === undefined">
      <b-table hover :items="invoices" show-empty></b-table>
    </b-card>
  </b-container>
</template>

<script>

import SelectCard from '@/components/SelectCard.vue'
import moment from 'moment'
import api from '@/lib/api.js'
import { db } from '@/main.js'

export default {
  name: 'settings',
  props: ['user', 'site', 'profile'],
  components: {SelectCard},
  firestore: function () {
    return {
      invoices: db.collection('site').doc(this.$route.params.site_id).collection('invoice').orderBy('created', 'desc')
    }
  },
  metaInfo() {
    return {
      title: `Settings`
    };
  },
  data() {
    return {
      is_saving: false,
      invoices: []
    }
  },
  methods: {
    can_update_plan() {
      if (this.profile.payment_method) {
        this.update_plan()
      } else {
        this.$refs.select_card.setup_billing()
        // Add a payment method, if successful then go here
      }
    },
    async update_plan() {
      this.is_saving = true
      await api.update_site_plan(this.$route.params.site_id, 'monthly_sites', 1)
      this.is_saving = false

      this.$bvToast.toast(`Plan updated`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})
    }
  },
  computed: {
    trial_days_left() {
      if (this.site && this.site.trial_end) {
        return moment(this.site.trial_end.toDate()).diff(moment(), 'days')
      }

      return undefined
    }
  },
}
</script>

<style scoped>

.header {
  padding: 0px;
}

.jumbotron {
  background: #353e58;
  margin-bottom: 0px !important;
}

.main {
  background: white;
  position: relative;
  top: -64px !important;
}

</style>
